import { combineReducers } from "redux";
import AllUserReducer from "./AllUserReducer";
import AllTypeReducer from "./AllTypeReducer";
import AllCustomerListReducer from "./AllCustomerListReducer";
import AllProjectListReducer from "./AllProjectListReducer";
import AllStateListReducer from "./AllStateListReducer";
import AllPerDiemListReducer from "./AllPerDiemListReducer";
import PageReducer from "./PageReducer";
import SortReducer from "./SortReducer";
import ActiveUserReducer from "./ActiveUserReducer";
import CheckUserReducer from "./CheckUserReducer";
import BillingStatementFilterReducer from "./BillingStatementFilterReducer";
import InvoiceListSelectReducer from "./InvoiceListSelectReducer";
import CustomerListSelectReducer from "./CustomerListSelectReducer";
import AdminBillingStatementFilter from "../../components/model/AdminBillingStatementFilter";
import AdminBillingStatementFilterReducer from "./AdminBillingStatementFilterReducer";
import ConsolidateInvoiceSelectReducer from "./ConsolidateInvoiceSelectReducer";
import AllNotificationDetailsReducer from "./AllNotificationDetails";
const RootReducer = combineReducers({
AllUserReducer,
AllTypeReducer,
AllNotificationDetailsReducer,
AllCustomerListReducer,
AllProjectListReducer,
AllStateListReducer,
AllPerDiemListReducer,
PageReducer,
SortReducer,
ActiveUserReducer,
CheckUserReducer,
billingStatementFilter: BillingStatementFilterReducer,
AdminBillingStatementFilter: AdminBillingStatementFilterReducer,
InvoiceListFilter: InvoiceListSelectReducer,
CustomerListSelectFilter: CustomerListSelectReducer,
ConsolidateInvoiceSelect: ConsolidateInvoiceSelectReducer
})
export default RootReducer;
